module.exports = __webpack_public_path__ + "static/media/DBHeaventBd.58c493b1.ttf";